import React, { Component } from 'react'
import PropTypes from 'prop-types'
import request from './../../assets/js/request'
import { handleName } from './../../assets/js/utils'
import './index.less'

class InviteInfo extends Component {
  static propTypes = {
      data: PropTypes.object
  };

  constructor (props) {
      super(props)
      this.state = {
          name: '',
          mobile: ''
      }
  }

  UNSAFE_componentWillMount () {
      this.getInviterInfo()
  }

  async getInviterInfo () {
      const params = new URLSearchParams(window.location.search)
      const { data } = await request.get('/gateway/v2/invite/getNameAndPicByInviteCode', {
          params: {
              inviteCode: params.get('gatewayInviteCode')
          }
      })
      const { name = '', mobile = '' } = data
      this.setState({
          name: handleName(name),
          mobile: mobile.substring(0, 3) + '****' + mobile.substring(7, 11)
      })
  }

  render () {
      let { style, title } = this.props.data
      const { name, mobile } = this.state
      if (!style) {
          style = {}
      }
      const { backgroundPicUrl = '', backgroundColor = '', textColor = '' } = style
      return (
          <div
              className="invite-info statistics-dom"
              style={{
                  backgroundColor: backgroundColor,
                  backgroundImage: `url(${backgroundPicUrl || ''})`
              }}
          >
              <i className="icon icon-msg" />
              <span style={{ color: `${textColor}` }}>
                  {title && title.split('{0}')[0]}
                  <span className="red">{name || mobile}</span>
                  {title && title.split('{0}')[1]}
              </span>
          </div>
      )
  }
}

export default InviteInfo
